<script setup lang="ts">
  import { RadioGroup as ArkRadioGroup } from '@ark-ui/vue';
  import { itemClass, itemControlClass, itemTextClass } from './RadioGroup.css';
  import type { RadioProps } from './RadioGroup.types';

  defineProps<RadioProps>();
</script>

<template>
  <ArkRadioGroup.Item :value="value" :disabled="disabled" :class="itemClass">
    <ArkRadioGroup.ItemControl :class="itemControlClass" />
    <ArkRadioGroup.ItemText :class="itemTextClass" :title="label">{{
      label
    }}</ArkRadioGroup.ItemText>
    <ArkRadioGroup.ItemHiddenInput />
  </ArkRadioGroup.Item>
</template>
